import React from "react";

export default function CategoryScreen({
  categories,
  labs,
  onSelectCategory
}) {
  return (
    <>
      <h2 style={{ marginTop: 30 }}>
        📂 Select a Lab Category
      </h2>

      <div style={styles.grid}>
        {categories.map((category) => {
          const count = labs.filter(
            lab => (lab.details?.category || "Others") === category
          ).length;

          return (
            <div
              key={category}
              style={styles.card}
              onClick={() => onSelectCategory(category)}
            >
              <h3>{category}</h3>
              <p>{count} Labs</p>
            </div>
          );
        })}
      </div>
    </>
  );
}

const styles = {
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(250px,1fr))",
    gap: 20,
    marginTop: 20
  },

  card: {
    background: "#161b22",
    border: "1px solid #333",
    borderRadius: 12,
    padding: 30,
    textAlign: "center",
    cursor: "pointer",
    color: "#fff",
    transition: "0.2s"
  }
};